// Voice control, one turn at a time: transcript, then gate, then matcher, then assistant.
//   transcript: the live words (partial while speaking, final after the pause), from voice/live.ts.
//   gate:       decides whether these words are for voice control at all. Today it lets everything through
//               (OPEN_GATE). The seam for a wake word ("Delta, open my reminders"), a short follow-up window after
//               a command, or hold-to-talk: a gate returns the words without the wake word, or null to ignore them.
//   matcher:    intents.ts, in the browser, on every partial: a confident command acts at once.
//   assistant:  everything else, as a short voice-control turn (the fast model), when the turn ends.
import { decide, NameIndex, type Decision } from './intents';

export interface Gate {
  readonly name: string;
  /** The words for voice control (a wake word taken off), or null: not for us, drop them. */
  admit(words: string, o: { final: boolean }): { words: string } | null;
}
export const OPEN_GATE: Gate = { name: 'open', admit: words => ({ words }) };

export type Route =
  | { to: 'act'; decision: Extract<Decision, { kind: 'act' }> }
  | { to: 'wait' }
  | { to: 'assistant'; words: string }
  | { to: 'drop' };

/** Pages only, until the names have loaded. */
const PAGES_ONLY = new NameIndex([]);

export function routeTurn(words: string, o: { final: boolean; path: string; index: NameIndex | null; gate: Gate }): Route {
  const g = o.gate.admit(words, { final: o.final });
  if (!g) return o.final ? { to: 'drop' } : { to: 'wait' };
  const d = decide(g.words, o.index ?? PAGES_ONLY, { final: o.final, path: o.path });
  if (d.kind === 'act') return { to: 'act', decision: d };
  return o.final ? { to: 'assistant', words: g.words } : { to: 'wait' };
}
